var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMalta(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_677)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.0002 40.0001C31.0459 40.0001 40.0002 31.0458 40.0002 20.0001C40.0002 8.95439 31.0459 8.7738e-05 20.0002 8.7738e-05C8.95449 8.7738e-05 0.000183105 8.95439 0.000183105 20.0001C0.000183105 31.0458 8.95449 40.0001 20.0002 40.0001Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0001 3.05176e-05C31.0457 3.05176e-05 40.0001 8.95441 40.0001 20C40.0001 31.0457 31.0457 40 20.0001 40",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9131 7.82615V5.21748H11.3044V7.82615H8.69568V10.4348H11.3044V13.0436H13.9131V10.4348H16.5218V7.82615H13.9131Z",
    fill: "#ACABB1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_677"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMalta);
export default __webpack_public_path__ + "static/media/malta.0749b47777518a194cd5794b671da3b8.svg";
export { ForwardRef as ReactComponent };